import { render } from "./StaffAssessmentDetailsPage.vue?vue&type=template&id=34160bc4"
import script from "./StaffAssessmentDetailsPage.vue?vue&type=script&lang=js"
export * from "./StaffAssessmentDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__